export interface ArtifactReference {
	workspaceId: string;
	id: string;
}

export interface GenericArtifact extends ArtifactReference {
	type: string;
	displayName: string;
	description: string;
	createdBy?: string;
	createdDate?: Date;
	lastModifiedBy?: string;
	lastModifiedDate?: Date;
}

export type SupportedArtifactType = 'data-warehouse' | 'Oracle' | 'Warehouse';

export enum API_STATUS {
	LOADING,
	SUCCESS,
	FAILURE,
}

export type ApiResponseType<T> =
	| {
			status: API_STATUS.LOADING;
	  }
	| {
			status: API_STATUS.FAILURE;
			errorMsg: string;
			error?: any;
	  }
	| {
			status: API_STATUS.SUCCESS;
			details: T;
	  };

export type TimeoutID = ReturnType<typeof setTimeout>;
